var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full font-bold"},[_c('div',{staticClass:"flex w-screen h-full"},[_c('side-nav')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }